export const ADD_TO_PRODUCTS_HISTORY = 'ADD_TO_PRODUCTS_HISTORY';

export const addToProductsHistory = (payload) => {
	return {
		type: ADD_TO_PRODUCTS_HISTORY,
		payload,
	};
};
